import React, { useEffect, useState } from 'react';
import DocumentLink from '../../components/documents/DocumentLink';
import PageTab from '../../components/dashboard/PageTab';
import PageTabTitle from '../../components/dashboard/PageTabTitle';
import PageTabBody from '../../components/dashboard/PageTabBody';

const ProtocolDocuments = () => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    try {
      const context = require.context('/public/meetingsDocuments/protocols', false, /\.pdf$/);
      const docs = context.keys();

      setDocuments(docs);
    } catch (error) {
      console.error("Directory '/public/meetingsDocuments/protocols' does not exist.");
    }
  }, []);

  return (
    <PageTab>
      <PageTabTitle>Susirinkimų protokolai</PageTabTitle>
      <PageTabBody>
        {documents.map((filename, index) => (
          <DocumentLink key={index} directory={'/meetingsDocuments/protocols'} filename={filename} />
        ))}
      </PageTabBody>
    </PageTab>
  );
};

export default ProtocolDocuments;
